import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import "./inventario.css";


export default class Inventario extends Component{

  state = {
    registros: [],
  };
  async componentDidMount() {
    const res = await axios.get("http://localhost:5000/api/Inventario/");
    this.setState({ registros: res.data });
  }

  render(){
    return(
      <>
          <div className="container inventario-container">
      <div className='row'>
            <div className='col-12'>
                <div className='inventario_title'>
                    <h1>Inventario</h1>
                </div>
            </div>
        </div>

        <div className='row'>
          <div className="col-md-12"> 
          <Link to="/Inventario/Nuevo">
                <button className="btn btn-secondary float-end">
                  Nuevo Registro
                </button>
              </Link>
          </div>        
        </div>
        <div className="row mb-3 mt-3">
          <div className="table-responsive">
          <table className="table">
              <thead>
                <tr>
                  <th>Inventario</th>
                  <th>Empleado</th>
                  <th>Serie</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
{this.state.registros.map((registro) => (

<>
<tr>
  <td> {registro.inventario } </td>
  <td> {registro.empleado } </td>
  <td> {registro.serie } </td>
  <td> {registro.observaciones } </td>
</tr>
</>
))

}
                
              </tbody>
            </table>
          </div>
          
        </div>
      
      <hr className="hr-gob" />
    </div>
      </>
    )
  }



}